import * as React from "react";
import { color } from "../../../styles/color";
import { ResultWrapper } from "../../../styles/DailyRecord";

interface IProps {
  storageSearchValue: {
    feetNo: string;
    matchNumber: string;
    memberName: string;
  };
  storageTime: [string | null, string | null];
  storageIsCheck: boolean | null;
}

const Result = ({
  storageTime,
  storageSearchValue,
  storageIsCheck,
}: IProps) => (
  <ResultWrapper>
    <div className="resultInfo">
      <p>
        搜寻日期：
        {storageTime[0] && storageTime[1]
          ? `${storageTime[0]} 至 ${storageTime[1]}`
          : ""}
      </p>
      <p>
        排除重复：
        {storageIsCheck === true ? "是" : storageIsCheck === null ? "" : "否"}
      </p>
      {storageSearchValue.matchNumber ? (
        <p>参赛编号：{storageSearchValue.matchNumber}</p>
      ) : null}
      {storageSearchValue.memberName ? (
        <p>参赛名称：{storageSearchValue.memberName}</p>
      ) : null}
      {storageSearchValue.feetNo ? (
        <p>足环号：{storageSearchValue.feetNo}</p>
      ) : null}
      {localStorage.getItem("onAuth") ? (
        <div style={{ color: `${color.default}`, fontSize: ".7rem" }}>
          ( 清零作业会影响统计数据 )
        </div>
      ) : null}
    </div>
  </ResultWrapper>
);

export default Result;
